import React, { useEffect } from 'react';
import Iconfont from '@base/lib/Iconfont';
import styles from './index.module.less';
import { Modal, Button } from 'antd';
import cn from 'classnames';
import { useTrans } from 'base/utils/i18n';
import Image from '@base/lib/ThemeImage';
import { IUseEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import { SharePopupM } from '@base/lib/share/SharePopupM';
import { SharePopupPC } from '@base/lib/share/SharePopupPC';
import { trackElement } from 'base/utils/tracker'
import { IListItem } from '@pro/activity/testerClub/interface'
import { IClickShareItem, IShareChannel } from '@base/lib/share/interface'

type IProps = {
    earlyAccess: IUseEarlyAccess;
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    product: IListItem
}

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const ApplySuccessPopup: React.FC<IProps> = (props) => {
    const { earlyAccess, visible, setVisible, product } = props;
    const { t } = useTrans();

    const { share } = earlyAccess

    const onClickShareItem = (item?: IClickShareItem) => {
        console.log({ item });
        trackElement({
            action: 'click',
            targetType: 'other',
            target: `Referral.${item?.channel || 'share'}`,
            module: `${isPhone ? 'H5' : 'WEB'} testerClubApplySuccess`,
            content: product.activityGid
        })
    }

    useEffect(() => {
        if (visible) {
            trackElement({
                action: 'impr',
                targetType: 'other',
                target: 'testerClubApplySuccessPopup',
                module: `${isPhone ? 'H5' : 'WEB'} testerClubApplySuccess`,
                content: product.activityGid
            })
        }
    }, [visible]);

    return (
        <Modal
            maskStyle={{
                background: 'rgba(0, 0, 0, 0.7)'
            }}
            closeIcon={<Iconfont style={{ color: 'white' }} className={'icon-close'}/>}
            className={styles['modal']}
            open={visible}
            onCancel={() => setVisible(false)}
            centered
            footer={false}
            maskClosable={false}
            width={isPhone ? '100%' : 1200}
        >
            <div className={cn(styles['content-wrap'], 'text-center')}>
                <div className={cn(styles['title'])}>
                    <p>{t('web_common_congratulations')}</p>
                    <p>{t('web_shop_activity_early_access_apply_success_tips')}</p>
                </div>

                <div className={styles['icon-wrap']}>
                    <Iconfont className={'icon-select2'}/>
                </div>

                <div className={styles.text}>
                    <p >
                        {t('web_shop_activity_early_access_more_way_boost_chances')}
                    </p>
                </div>

                <div className={cn(styles['card-wrap'], 'text-left')}>
                    <div className={cn(styles['card'])}>
                        <div className={'share-icon'}>
                            <Image
                                src={'asset/width-64/picture/f98b96eecf3bf5335cac799a6b7bd48c.png'}
                                width={32}
                                height={32}
                                fixed
                                background={false}
                            />
                        </div>

                        <div className={styles['info']}>
                            <p className={styles['card-title']}>{t('web_shop_activity_early_access_share_the_activity')}</p>

                            <p className={styles['card-msg']}>{t('web_shop_activity_early_access_invite_friends')}</p>
                        </div>

                        <div className={cn(styles['card-share'],'text-right')}>
                            {isPhone ? (
                                <SharePopupM
                                    media={share?.media}
                                    title={share?.title}
                                    url={share?.url || ''}
                                    showThumb={true}
                                    shareUrls={share?.shareUrls}
                                    onClickItem={onClickShareItem}
                                >
                                    {({open}) => (
                                        <Button
                                            size={'small'}
                                            className={styles['go-btn']}
                                            shape={'round'}
                                            type={'primary'}
                                            onClick={()=> {
                                                setVisible(false);
                                                open()
                                            }}
                                        >Go</Button>
                                    )}
                                </SharePopupM>
                            ) : (
                                <SharePopupPC
                                    url={share?.url || ''}
                                    onClickItem={onClickShareItem}
                                >
                                    <Button
                                        size={'small'}
                                        className={styles['go-btn']}
                                        shape={'round'}
                                        type={'primary'}
                                    >Go</Button>
                                </SharePopupPC>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ApplySuccessPopup